<template>
    <section id="federer" class="TBS">
      <h2 class="TBS__title">Pour fédérer</h2>
  
      <nav class="TBS__tabs" role="tablist">
        <button
          v-for="(a, i) in items"
          :key="a.id || i"
          class="TBS__tab"
          role="tab"
          :class="{ active: i===active }"
          @click="active = i"
        >
          {{ a.title }}
        </button>
      </nav>
  
      <div v-if="current" class="TBS__content">
        <!-- Desktop grid -->
        <div class="TBS__grid">
          <div class="TBS__img TBS__img--lg" v-if="current.photo_urls[0]">
            <img :src="current.photo_urls[0]" :alt="`${current.title} 1`" />
          </div>
          <div class="TBS__img" v-if="current.photo_urls[1]">
            <img :src="current.photo_urls[1]" :alt="`${current.title} 2`" />
          </div>
          <div class="TBS__img" v-if="current.photo_urls[2]">
            <img :src="current.photo_urls[2]" :alt="`${current.title} 3`" />
          </div>
        </div>
  
        <div class="TBS__side">
          <div class="TBS__block">
            <div class="TBS__k">PRINCIPES</div>
            <div class="TBS__v">{{ current.principles_text }}</div>
          </div>
  
          <div class="TBS__block">
            <div class="TBS__k">CONDITIONS</div>
  
            <ul class="TBS__conds">
              <li v-if="current.place_text">
                <span class="ico" v-html="icons.place" aria-hidden="true"></span>
                <span class="lab">{{ current.place_text }}</span>
              </li>
              <li v-if="current.format_text">
                <span class="ico" v-html="icons.team" aria-hidden="true"></span>
                <span class="lab">{{ current.format_text }}</span>
              </li>
              <li v-if="current.capacity_text">
                <span class="ico" v-html="icons.person" aria-hidden="true"></span>
                <span class="lab">{{ current.capacity_text }}</span>
              </li>
              <li v-if="current.duration_text">
                <span class="ico" v-html="icons.clock" aria-hidden="true"></span>
                <span class="lab">{{ current.duration_text }}</span>
              </li>
              <li v-if="current.price_text">
                <span class="ico" v-html="icons.euro" aria-hidden="true"></span>
                <span class="lab">{{ current.price_text }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
  
      <!-- Mobile carousel -->
      <div v-if="current && current.photo_urls.length" class="TBS__mobile">
        <div class="TBS__slider">
          <button class="nav prev" @click="prev">‹</button>
          <img :src="current.photo_urls[mobIndex]" :alt="`${current.title} ${mobIndex+1}`" />
          <button class="nav next" @click="next">›</button>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'TeamBuildingSection',
    props: { items: { type: Array, default: () => [] } },
    data(){ return {
      active: 0,
      mobIndex: 0,
      icons: {
        place: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2d5f49" stroke-width="2"><path d="M3 12h14"/><path d="M14 7l5 5-5 5"/></svg>`,
        team: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2d5f49" stroke-width="2"><circle cx="8" cy="8" r="3"/><circle cx="16" cy="8" r="3"/><path d="M2 20c0-3.3 2.7-6 6-6"/><path d="M22 20c0-3.3-2.7-6-6-6"/></svg>`,
        person:`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2d5f49" stroke-width="2"><circle cx="12" cy="7" r="4"/><path d="M5.5 21c1.5-3 4.3-5 6.5-5s5 2 6.5 5"/></svg>`,
        clock:`<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2d5f49" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 7v6l4 2"/></svg>`,
        euro: `<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2d5f49" stroke-width="2"><path d="M17 7a6 6 0 0 0-6-2 6 6 0 0 0 0 14 6 6 0 0 0 6-2"/><path d="M3 10h8"/><path d="M3 14h8"/></svg>`
      }
    }},
    computed:{
      current(){ return this.items?.[this.active] || null }
    },
    methods:{
      next(){ if(!this.current) return; this.mobIndex = (this.mobIndex + 1) % this.current.photo_urls.length },
      prev(){ if(!this.current) return; this.mobIndex = (this.mobIndex + this.current.photo_urls.length - 1) % this.current.photo_urls.length }
    }
  }
  </script>
  
  <style scoped>
  .TBS{padding:24px 16px}
  .TBS__title{
    font-family: 'Merriweather';
    font-weight: 400;
    font-size: 24px;
    margin: 0 0 8px;
    text-align:center;margin:0 0 14px;color:#0d0d0d}
  .TBS__tabs{display:flex;gap:28px;justify-content:center;flex-wrap:wrap;border-bottom:1px solid #e5e7eb;margin-bottom:18px}
  .TBS__tab{background:transparent;border:0;padding:10px 4px;font-weight:800;letter-spacing:.2px;color:#0f0f0f;border-bottom:3px solid transparent}
  .TBS__tab.active{border-color:#2d5f49;color:#2d5f49}
  .TBS__content{display:grid;grid-template-columns:1.2fr .8fr;gap:28px;max-width:1200px;margin:0 auto}
  .TBS__grid{display:grid;grid-template-columns:1fr 1fr;grid-template-rows:auto auto;gap:12px}
  .TBS__img{border-radius:8px;overflow:hidden;background:#f5f5f5}
  .TBS__img img{width:100%;height:100%;object-fit:cover;display:block}
  .TBS__img--lg{grid-column:1/3;height:420px}
  .TBS__grid .TBS__img:not(.TBS__img--lg){height:220px}
  .TBS__side{display:grid;gap:18px;align-content:start}
  .TBS__block{background:#ffffff;border-radius:10px;padding:18px;border:1px solid #e5e7eb}
  .TBS__k{font-family:'Raleway',sans-serif;font-weight:800;color:#2d5f49;margin-bottom:8px}
  .TBS__v{color:#0f0f0f;line-height:1.8}
  .TBS__conds{list-style:none;padding:0;margin:0;display:grid;gap:14px}
  .TBS__conds li{display:grid;grid-template-columns:28px 1fr;gap:12px;align-items:center}
  .ico{width:24px;height:24px;display:inline-grid;place-items:center}
  .TBS__mobile{display:none;margin-top:12px}
  .TBS__slider{position:relative}
  .TBS__slider img{width:100%;max-width:640px;height:360px;object-fit:cover;border-radius:10px;display:block;margin:0 auto}
  .nav{position:absolute;top:50%;transform:translateY(-50%);background:rgba(0,0,0,.45);color:#fff;border:0;border-radius:999px;width:36px;height:36px;cursor:pointer}
  .prev{left:8px} .next{right:8px}
  
  @media (max-width: 980px){
    .TBS__content{grid-template-columns:1fr;gap:16px}
    .TBS__grid{display:none}         /* hide desktop grid */
    .TBS__mobile{display:block}      /* show mobile slider */
  }
  </style>
  